<ion-content>
  <div class="con-spin">
    <ion-spinner name="circular"></ion-spinner>
  </div>
</ion-content>
